import { render, staticRenderFns } from "./assetInventoryIn.vue?vue&type=template&id=21a27bdc&scoped=true"
import script from "./assetInventoryIn.vue?vue&type=script&lang=js"
export * from "./assetInventoryIn.vue?vue&type=script&lang=js"
import style0 from "./assetInventoryIn.vue?vue&type=style&index=0&id=21a27bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a27bdc",
  null
  
)

export default component.exports